import React from "react";
import { type CommonReactSelectWrapperProps } from "../models";
import { useReactSelectDropdown, type UseSearchQuery } from "../hooks";
import { type UseQueryResult } from "@tanstack/react-query";
import ReactSelect, { components } from "react-select";
import ErrorTryAgainLabel from "../ErrorTryAgainLabel";

export interface ApiWrapperProps<TOption extends unknown, TId = number> extends CommonReactSelectWrapperProps<TOption, false, TId> {
  query: UseQueryResult<TOption[]>
  options: TOption[]
  searchQuery: UseSearchQuery
}

/**
 * Does an API call after every (debounced) keypress
 */
const BaseApiDropdown = <TOption extends unknown, TId = number>(props: ApiWrapperProps<TOption, TId>) => {
  const reactSelect = useReactSelectDropdown(props);

  const isLoading = props.query.isFetching || props.searchQuery.isDebouncing;

  return <ReactSelect
    {...reactSelect.reactSelectProps}
    key={props.dropdownKey}
    ref={reactSelect.ref}
    options={isLoading ? [] : (props.options ?? [])}
    isLoading={isLoading}
    onInputChange={props.searchQuery.setSearchQuery}
    isSearchable
    components={{
      ...reactSelect.reactSelectProps.components,
      NoOptionsMessage: noOptsProps => {
        if (props.query.error) {
          return <components.NoOptionsMessage {...noOptsProps}>
            <ErrorTryAgainLabel onTryAgain={async () => props.query.refetch()} />
          </components.NoOptionsMessage>;
        }
      }
    }}

  />;
};

export default BaseApiDropdown;